/* eslint-disable vue/sort-keys */
import {
  ResponsiveLayout,
} from '@robovision/rvai-base'
import { RouteNames } from '../moduleRouteNames/topology'
import type { RvaiRouteRecord } from '../types'


// We need to ignore "imports" for components properties in routes,
// because without it we have no possibility to import (dynamically) pages for specific router.
// Normally we don't need to import something from "pages" into router,
// but eslint doesn't know the difference between normal and dynamic imports.
export const routes: RvaiRouteRecord<RouteNames> = {
  path: '/topology',
  component: ResponsiveLayout,
  meta: {
    can: ['read', 'Inference'],
  },

  children: [
    {
      // eslint-disable-next-line import/no-restricted-paths
      component: () => import('~modules/topology/pages/Topology.vue'),
      path: '',

      children: [
        {
          path: '',
          name: RouteNames.Topology,
          redirect: { name: RouteNames.PlatformConnections },
        },
        {
          // eslint-disable-next-line import/no-restricted-paths
          component: () => import('~modules/topology/components/PlatformConnectionsContent.vue'),
          name: RouteNames.PlatformConnections,
          path: 'platform-connections',
        },
      ],
    },
  ],
}
